import { bambiApi } from 'src/common/external/bambi-api/bambiApi';

// https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting#enhanceendpoints
// TODO: use this to remove as much of post-process.js as possible
const enhancedBambiApi = bambiApi.enhanceEndpoints({
  endpoints: {
    dispatchRetrieve: {
      providesTags: ['dispatch', 'trips', 'assignments'],
    },
    tripsValidatePartialUpdate: {
      // We don't want to actually invalidate trips, dispatch, or run-bambi-run tagged queries on this update
      // See https://bambihealth.atlassian.net/browse/BAM-793 and related prs for more context
      // This essentially prevents a race condition where /dispatch/ is invalidated after a /validate/ call
      // and /dispatch/ is fetched before a /assign/ or /reassign/ call completes. The /assign/ and /reassign/ calls
      // sometimes invalidate /dispatch/ too close to the /dispatch/ call and rtk-query will not refetch /dispatch/
      // This results in a stale ui
      invalidatesTags: [],
    },
    organizationSettingsPartialUpdate: {
      invalidatesTags: ['organizations', 'user'],
    },
    passengersDestroy: {
      invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
    },
    passengersUndeleteCreate: {
      invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
    },
    invoicesInvoicesCreate: {
      invalidatesTags: ['billing', 'invoices'],
    },
    tripsMultiloadCreate: {
      invalidatesTags: ['dispatch', 'trips'],
    },
    tripsMultiloadPartialUpdate: {
      invalidatesTags: ['dispatch', 'trips'],
    },
    tripsMultiloadDestroy: {
      invalidatesTags: ['dispatch', 'trips'],
    },
    tripsUnassignPartialUpdate: {
      invalidatesTags: ['dispatch', 'trips'],
    },
    tripsBulkUnassignCreate: {
      invalidatesTags: ['dispatch', 'trips'],
    },
    // This doesn't actually change data
    tripsBulkValidateCreate: {
      invalidatesTags: [],
    },
    tripTagsCreate: {
      invalidatesTags: ['dispatch', 'trips', 'tags'],
    },
    tripTagsDestroy: {
      invalidatesTags: ['dispatch', 'trips', 'tags'],
    },
    driverTagsList: {
      providesTags: ['drivers', 'tags'],
    },
    driverTagsCreate: {
      invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
    },
    driverTagsDestroy: {
      invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
    },
    vehicleTagsList: {
      providesTags: ['vehicles', 'tags'],
    },
    vehicleTagsCreate: {
      invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
    },
    vehicleTagsDestroy: {
      invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
    },
    tilledPaymentMethodVerifyCreate: {
      invalidatesTags: ['tilled'],
    },
    invoicesPaymentLinkCreate: {
      // Don't invalidate the invoices list because it causes a refresh bug in
      // the payment modal, which resets the payer list. At the time of writing
      // this, we don't rely on creating a payment link to refresh any data.
      invalidatesTags: [],
    },
    tripsBulkPriceCreate: {
      // This was causing the trip list to refresh.
      // No trip data has been changed at this point, so no need to invalidate any tags.
      invalidatesTags: [],
    },
  },
});

export { enhancedBambiApi };
